import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectRepeatedInputFailures(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { wisdomMessages } = context;

  if (!wisdomMessages || wisdomMessages.length === 0) return problems;

  // Look for repeated empty customer inputs followed by similar bot responses
  const emptyCustomerInputs = wisdomMessages.filter(
    (msg) => msg.participant === 'CUSTOMER' && msg.value.text.value === ''
  );

  if (emptyCustomerInputs.length >= 4) {
    problems.push({
      id: generateId(),
      type: ProblemType.REPEATED_INPUT_FAILURE,
      severity: ProblemSeverity.MEDIUM,
      title: 'Repeated Input Recognition Failures',
      description: `Customer input not recognized ${emptyCustomerInputs.length} times`,
      timestamp: emptyCustomerInputs[0].timestamp,
      source: 'WISDOM_TRANSCRIPT',
      relatedData: { failureCount: emptyCustomerInputs.length },
      suggestions: [
        'Review speech recognition settings',
        'Check for background noise issues',
        'Consider improving bot prompts for clarity'
      ]
    });
  }

  return problems;
}
